import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import { Caption } from 'components/Typography'
import { motion } from 'framer-motion'
import { BREAKPOINTS } from 'utils/styled'

const jumpKeyframes = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
`

export const StepsGuide = styled.div`
  max-width: 100%;
  position: relative;
  display: grid;
  overflow: hidden;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 7.25rem;

  @media ${BREAKPOINTS.LG.max} {
    column-gap: 4.5rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    grid-template-columns: 1fr;
    column-gap: 2rem;
  }
`

export const Line = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--c-blue100);
  @media ${BREAKPOINTS.MD.max} {
    top: 0;
    left: 0;
    bottom: 0;
    height: auto;
    width: 2px;
  }
`

export const StepsGuideItem = styled.article`
  position: relative;
  max-width: 100%;
  @media ${BREAKPOINTS.MD.max} {
    padding-left: 20px;
    &:not(:last-child) {
      margin-bottom: 2rem;
    }
  }
`

export const StepsGuideItemIcon = styled.div<{ active?: boolean }>`
  margin-bottom: 1rem;
  & > *,
  & img {
    max-width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: 0.75rem;
  }

  ${({ active }) => {
    if (active) {
      return css`
        & > *,
        & img {
          animation: ${jumpKeyframes} 0.6s 1 ease-in-out;
        }
      `
    }
    return null
  }}
`

export const StepsGuideItemCaption = styled(Caption)<{ singleLine?: boolean }>`
  color: var(--c-gray100);
  margin-bottom: 10px;
  @media ${BREAKPOINTS.MD.min} {
    min-height: ${({ singleLine }) => (singleLine ? '1.5rem' : '3rem')};
  }
`

export const StepsGuideItemProgress = styled(motion.div)`
  width: 100%;
  height: 2px;
  background: var(--c-blue500);
  position: absolute;

  @media ${BREAKPOINTS.MD.max} {
    height: 100%;
    width: 2px;
    top: 0;
    left: 0;
    bottom: 0;
  }
`
